import _extends from "@babel/runtime/helpers/extends";
import merge from 'lodash/merge';
import mapValues from 'lodash/mapValues';
import forEach from 'lodash/forEach';
import { initial, format, setLocaleToInstance } from "../utils/StringFomat";
import { getLangValue, getRandomKey, convertPandaI18nFormatToLocalResource, setCookieLang, warn, debugInfo, formatLang, error, getOSLang, setCookieKey, debugFunction } from "../utils";
import { DEFAULT_LOCAL_KEY, VERSION, PANDA_I18N_INSTANCE, PANDA_I18N_PACK, PANDA_EXUI } from "../const";
import { pandaEvent, setConfig } from "../services";
var cacheI18ns = [];
function makeCacheI18n($i18n, params) {
  if (params === void 0) {
    params = {};
  }
  if (typeof cacheI18ns === 'undefined') {
    return;
  }
  cacheI18ns.push({
    params: params,
    $i18n: $i18n
  });
}

// 为了兼容老的代码，这里暂时保留一个占为的对象
var localeUtil = {
  locale: {
    getLocale: function getLocale() {
      warn('Legacy api! Please use $i18n.getLang instead!');
      return {
        lang: defaultI18n.getLang()
      };
    },
    setLang: function setLang(lang) {
      warn('Legacy api! Please use $i18n.setLang instead!');
      defaultI18n.setLang(lang);
    }
  }
};
var I18n = /*#__PURE__*/function () {
  /**
   * 用组件自持有翻译初始化stringformat实例
   * @param {object} locale 组件自持有翻译
   * @param {string} defaultLang 自定义语种
   */

  /** 当前实例的实际语种 */

  /** $i18n组件名（组件独有） */

  /** $i18n组件包名 (组件独有) */

  /** 标识 */

  /** $i18n实例名 */

  /** 历史遗留的util类，兼容 不再维护 */

  /** 当前实例是否被初始化标记位 */

  /** 自定义的语种，设置后该实例语种不再受环境语种影响 */

  function I18n(params) {
    var _this = this;
    this.locale = {};
    this.currentLang = '';
    this.componentName = '';
    this.packageName = '';
    this.type = void 0;
    this.name = void 0;
    this.localeUtil = localeUtil;
    this.initFlag = true;
    this.customLang = void 0;
    /** 设置Panda全局配置 */
    this.setConfig = setConfig;
    this.componentName = (params === null || params === void 0 ? void 0 : params.componentName) || '';
    this.type = params === null || params === void 0 ? void 0 : params.type;
    this.packageName = params === null || params === void 0 ? void 0 : params.packageName;
    // 当前如果用了packageName方案则不再生成随机值，后续多packageName的实例将覆盖
    this.name = this.componentName ? this.componentName + "." + (this.packageName || getRandomKey()) : getRandomKey();
    // 当指定了lang之后该实例将锁定lang，不再受环境和事件影响
    if (params !== null && params !== void 0 && params.lang) {
      this.customLang = params.lang;
    }
    if (params !== null && params !== void 0 && params.locale && this.componentName) {
      // 组件可能传递是会多一层nameSpace，需要脱离，如果是组件不需要合并cdn的文案
      // TLocalResource | TLocalResourceWithNs => TLocalResource
      this.locale = mapValues(params.locale, function (_langLocale) {
        return _langLocale[_this.componentName] || _langLocale;
      });
      // 合并语言包文案
      if (window[PANDA_EXUI]) {
        Object.keys(window[PANDA_EXUI]).forEach(function (lang) {
          if (window[PANDA_EXUI][lang][_this.componentName]) {
            _this.locale[lang] = merge(_this.locale[lang] || {}, window[PANDA_EXUI][lang][_this.componentName]);
          }
        });
      }
    } else {
      this.locale = merge({}, convertPandaI18nFormatToLocalResource(window[PANDA_I18N_PACK]), (params === null || params === void 0 ? void 0 : params.locale) || {});
      setCookieKey();
    }
    this.currentLang = (params === null || params === void 0 ? void 0 : params.lang) || getLangValue();
    pandaEvent.on('CHANGE_LANG', function (lang) {
      if (!_this.customLang) {
        _this.currentLang = lang;
      }
    });
    if (params !== null && params !== void 0 && params._init) {
      // 如果是默认实例，将实例名放到对象，用于排查问题
      window.__PANDA.instanceNames.push(this.name);
      this.initFlag = false;
      debugInfo(this.name + ": " + VERSION);
    }
    // lang只记录强制lang，环境lang跟随环境走
    initial(this.locale, {
      name: this.name,
      lang: this.customLang
    });
  }
  var _proto = I18n.prototype;
  _proto.init = function init(params) {
    // 如果原实例被记入一个type/packageName，由此新生成的实例也将被打入同一个type/packageName
    return new I18n(_extends({}, params, {
      packageName: (params === null || params === void 0 ? void 0 : params.packageName) || this.packageName,
      type: (params === null || params === void 0 ? void 0 : params.type) || this.type
    }));
  }

  /**
   * change current language
   * @deprecated 之后将逐步废弃此方法
   */;
  _proto.change = function change(langTag) {
    warn('Legacy api! Please use $i18n.setLang instead!');
    this.setLang(langTag);
  }

  /**
   * change current language
   * @param {string} langTag language tag
   */;
  _proto.setLang = function setLang(langTag) {
    // 由于后续的文案消费依赖标准的format，故设置需要做处理
    var standardLang = formatLang(langTag);
    if (standardLang !== langTag) {
      error(langTag + " is not a valid language tag, panda converts to " + standardLang + " instead\uFF0Cplease check usage.");
    }
    // set cookie, 由于使用中依然 后端可能存在依然使用老的规范，故设置cookie依然使用用户设置的值
    setCookieLang(langTag);
    // set window
    this.currentLang = standardLang;
    window.__PANDA.lang = standardLang;
    // 为了确保环境变量的一致性，需要将localStorage的值也更新
    if (window.__PANDA.localLang) {
      window.__PANDA.localLang = standardLang;
    }
    // set localStorage
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(DEFAULT_LOCAL_KEY, standardLang);
    }
    debugInfo('Set lang to ' + standardLang);
    pandaEvent.emit('CHANGE_LANG', standardLang);
  }

  /** get current language */;
  _proto.getLang = function getLang() {
    return this.currentLang;
  }

  /** Format string by key */;
  _proto.get = function get(keyValue, variable) {
    var _keyValue$id;
    // 为了处理加载时序的问题，针对CDN场景，在第一次使用$i18n.get时再进行实际的实例化
    if (!defaultI18n.initFlag) {
      defaultI18n.initFlag = true;
      setCookieKey();
      defaultI18n.currentLang = defaultI18n.customLang || getLangValue();
      window.__PANDA.lang = defaultI18n.currentLang;
      defaultI18n.addLocale(convertPandaI18nFormatToLocalResource(window[PANDA_I18N_PACK]));
    }
    var id = typeof keyValue === 'string' ? keyValue === null || keyValue === void 0 ? void 0 : keyValue.trim() : (_keyValue$id = keyValue.id) === null || _keyValue$id === void 0 ? void 0 : _keyValue$id.trim();
    var defaultMessage = typeof keyValue === 'string' ? keyValue : keyValue.dm;
    // namespace 当前只针对组件名
    var nameSpace = typeof keyValue === 'string' ? this.componentName : keyValue.ns || this.componentName;
    // 指定语种
    var lang = typeof keyValue === 'object' && keyValue.lang ? keyValue.lang : this.currentLang;
    return format({
      id: id,
      defaultMessage: defaultMessage
    }, variable || null, {
      name: this.name,
      type: this.type,
      nameSpace: nameSpace,
      lang: lang,
      packageName: this.packageName
    });
  }

  /** 在当前$i18n实例中添加翻译文案 */;
  _proto.addLocale = function addLocale(locale) {
    this.locale = merge(this.locale, locale);
    setLocaleToInstance(this.locale, this.name);
  }

  /**
   * 在当前$i18n实例中替换locale文案, 可指定自定义组件名来标识实例来源
   * @param locale
   * @param packageName 包名（插件工程建议projectName）
   */;
  _proto.setLocale = function setLocale(locale, packageName) {
    this.locale = locale;
    this.packageName = packageName || getRandomKey();
    setLocaleToInstance(this.locale, this.name);
    if (!defaultI18n.initFlag) {
      defaultI18n.initFlag = true;
      defaultI18n.currentLang = defaultI18n.customLang || getLangValue();
    }
  }

  /** 在当前$i18n实例增量添加翻译文案 */;
  _proto.addLocaleByKey = function addLocaleByKey(locale) {
    var _this2 = this;
    forEach(locale, function (langLocale, key) {
      forEach(langLocale, function (value, lang) {
        _this2.locale[lang] = _this2.locale[lang] || {};
        _this2.locale[lang][key] = value;
      });
    });
    setLocaleToInstance(this.locale, this.name);
  }

  /** 重新加载语言包资源到当前$i18n实例 */;
  _proto.reloadPackLocale = function reloadPackLocale() {
    this.addLocale(convertPandaI18nFormatToLocalResource(window[PANDA_I18N_PACK]));
  }

  /** 设置该实例的自定义的lang (Pay attention to usage) */;
  _proto.setCustomLang = function setCustomLang(lang) {
    this.currentLang = lang;
    this.customLang = lang;
  }

  /** 根据key返回翻译列表 */;
  _proto.getLocaleByKey = function getLocaleByKey(key) {
    var myLocale = {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    forEach(this.locale, function (locale, lang) {
      myLocale[lang] = locale[key] || '';
    });
    return myLocale;
  }

  /** 将当前实例置入到全局的低码环境中 */;
  _proto.initLowcode = function initLowcode() {
    window.$i18n_lowcode = this;
  }

  /** 将该实例锁定为OS环境的语种，如不在os环境中则不会生效 */;
  _proto.lockOSLang = function lockOSLang() {
    var osLang = getOSLang();
    if (osLang) {
      this.setCustomLang(osLang);
    }
  }

  /** 设置一个标记位，标识该实例，开发专用!!! */;
  _proto.__setType = function __setType(type) {
    this.type = type;
  }

  /** 初始化组件包实例（将初始化多个实例） */;
  _proto.initPackage = function initPackage(_ref) {
    var _this3 = this;
    var name = _ref.name,
      locales = _ref.locales;
    this.packageName = name;
    if (locales) {
      var componentMap = {};
      Object.values(locales).forEach(function (locale) {
        Object.keys(locale).forEach(function (ns) {
          if (typeof locale[ns] === 'string') {
            error('no support locales type');
          } else if (!componentMap[ns]) {
            componentMap[ns] = _this3.init({
              componentName: ns,
              locale: locales
            });
          }
        });
      });
    }
  };
  return I18n;
}(); // _init 标记为默认的$i18n实例（cdn）
var defaultI18n = new I18n({
  _init: true
});
// debug模式加入到window变量中
debugFunction(function () {
  if (!window[PANDA_I18N_INSTANCE] || window[PANDA_I18N_INSTANCE].locale) {
    window[PANDA_I18N_INSTANCE] = defaultI18n;
  }
});
export var init = function init(params) {
  return defaultI18n.init(params);
};
export { I18n };
export default defaultI18n;